import './App.css';
import Header from './Header';
import GameWindow from './GameWindow';
import Footer from './Footer';

function App() {
  return (

    <div className="App">
      <Header />
        <p className="welcome-text">
        Welcome to Ripple Effects – an immersive simulation game that teaches you about water management! <br/><br/>
        Explore diverse locations throughout Aquaville, where each area presents unique challenges and scenarios. 
        As you navigate the town, you'll have the opportunity to harness resources and craft innovative policies that can transform Aquaville's future. Get ready to dive in, make strategic decisions, 
        and witness how your actions create ripple effects that shape a sustainable community. <br/><br/>
        If you have comments or questions, please contact us at infewsunl@gmail.com.
        </p>
      <GameWindow />
      <Footer />
    </div>
  );
}

export default App;
